<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1355_6208)">
            <path d="M0 8.51046L5.4791 14L16 3.48952L14.4896 1.99995L5.4791 10.9999L1.48953 7.01041L0 8.51046Z"
                fill="white" />
        </g>
        <defs>
            <clipPath id="clip0_1355_6208">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>